import {map, share} from 'rxjs/operators';
import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {EMPTY, Observable} from 'rxjs';
import {isPlatformBrowser, Location} from '@angular/common';
import {PromotionApiModel, PromotionService} from 'api-client';

const PROMO_URL_PART = 'promo/';
const PROMO_COOKIE_NAME = 'cbfp_promo';

@Injectable()
export class AffiliateService {

    promotion: Observable<PromotionApiModel> = null;

    constructor(private promotionService: PromotionService,
                @Inject(PLATFORM_ID) private platformId: Object,
                private location: Location) {
        const promoName = this.findPromo();
        if (promoName) {
          this.promotion = this.promotionService.getPromotion(promoName).pipe(
                map(result => {
                  // set cookie:
                  const date = new Date();
                  date.setTime(date.getTime() + (1000 * 60 * 60 * 24 * 30)); // 30 days
                  const expires = 'expires=' + date.toUTCString();
                  document.cookie = PROMO_COOKIE_NAME + '=' + promoName + ';' + expires + ';path=/';

                  return result;
                }),
                share(), );
        } else {
            this.promotion = EMPTY;
        }
    }

    private findPromo() {
        const path = this.location.path(false);
        const promoUrlIndex = path.indexOf(PROMO_URL_PART);
        if (promoUrlIndex > -1) {
            return path.substring(promoUrlIndex + PROMO_URL_PART.length);
        } else if (isPlatformBrowser(this.platformId)) {
            const promoCookie = document.cookie.split('; ').find(row => row.startsWith(PROMO_COOKIE_NAME + '='))?.split('=')[1];
            console.log('promo cookie: ', promoCookie);
            return promoCookie;
        } else {
            return null;
        }
    }

}
